import { gql } from 'graphql.macro'
import AccountFragment from '../../lib/AccountFragment'

export default gql`
  mutation CreateAccount($data: AccountDataInput!) {
    createAccount(data: $data) {
      ...AccountFragment
    }
  }

  ${AccountFragment}
`
